import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import $ from 'jquery'
import purify from 'dompurify'
import { getCmsContent_action } from "../../../actions/cms_action/cmsAction";
import { toastError } from "../../../utils/constants";

class StaticFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            footerData: []
        };
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    componentDidMount() {
        if (Array.isArray(this.props.footerData) && this.props.footerData.length > 0) {
            this.setState({ footerData: this.props.footerData })
        } else {
            console.log('else header')
            this.getCmsContent(1, 'home');
        }
    }
    getCmsContent = async (MenuID, MenuUrl) => {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, MenuUrl ? MenuUrl : 'home');
            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    footerData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    
    onClickLoginSignUp() {
        sessionStorage.removeItem("award_event_profile_id")
        this.props.navigate('/signUp')
    }

    render() {
        const { footerData } = this.state;
        return (
            <>
                {(footerData && footerData.isActive) && (
                    < div
                        dangerouslySetInnerHTML={{
                            __html: purify.sanitize(footerData?.FooterContent),
                        }}
                    />
                )}
                {/* <footer className="pt-9 text-center text-white position-relative z-1">
                    <div
                        className="z-n1 start-0"
                        style={{ backgroundColor: "#ffffff !important" }}
                    />
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 text-dark">
                                <h6 className="mb-2">
                                    THE TEXTILE &amp; TEXTILE ENGINEERING INDUSTRY{" "}
                                </h6>
                                <img
                                    src="static/images/footer-logo.png"
                                    alt="Logo"
                                    className="mb-3 mt-1"
                                    style={{ width: 125 }}
                                />
                                <p className="text-justify" style={{ fontSize: 15 }}>
                               <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                                </p>
                            </div>
                            <div className="col-md-2 mobile-top-space" style={{ textAlign: "left" }}>
                                <div className="about-award-footer">
                                    <h6 className="mb-2">ABOUT AWARDS</h6>
                                    <ul>
                                        <li>
                                            <Link to="/aboutIndiaITMEAwards">
                                                <i className="fa fa-angle-right" /> About India ITME Awards
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/aboutOrganiserIndiaITMESociety">
                                                <i className="fa fa-angle-right" /> About Organiser - India ITME Society
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/chairmanInvite">
                                                <i className="fa fa-angle-right" /> Chairman Invite
                                            </Link>
                                        </li>
                                        <li style={{ cursor: 'pointer' }} onClick={() => {
                                            this.props.navigate("/previousEditions", { state: { screen: 'previousEditions_2019' } });
                                            // this.loadscript()
                                            setTimeout(() => window.location.reload(), 100);
                                        }}>
                                            <i className="fa fa-angle-right" /> Edition 2019
                                        </li>
                                        <li style={{ cursor: 'pointer' }} onClick={() => {
                                            this.props.navigate("/previousEditions", { state: { screen: 'previousEditions_2022' } });
                                            // this.loadscript()
                                            setTimeout(() => window.location.reload(), 100);
                                        }}>
                                            <i className="fa fa-angle-right" /> Edition 2022
                                        </li>
                                        <li>
                                            <Link to="/videos">
                                                <i className="fa fa-angle-right" /> Videos
                                            </Link>
                                        </li>
                                        <li style={{ cursor: 'pointer' }} onClick={() => this.onClickLoginSignUp()}>
                                            <i className="fa fa-angle-right" /> Register Now{" "}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-2 mobile-top-space" style={{ textAlign: "left" }}>
                                <div className="about-award-footer">
                                    <h6 className="mb-2">HELPFUL LINKS</h6>
                                    <ul>
                                        <li>
                                            <Link to="/press_release">
                                                <i className="fa fa-angle-right" /> Press Release
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/media_coverage">
                                                <i className="fa fa-angle-right" /> Media Coverage{" "}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/MediaKit">
                                                <i className="fa fa-angle-right" /> Media Kit{" "}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/associateandpartners">
                                                <i className="fa fa-angle-right" /> Associates and &nbsp; &nbsp;
                                                &nbsp; &nbsp; &nbsp; &nbsp; Partners{" "}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/jury">
                                                <i className="fa fa-angle-right" /> Our Jury{" "}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/contactUS">
                                                <i className="fa fa-angle-right" /> Contact{" "}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 mobile-top-space" style={{ textAlign: "left" }}>
                                <div className="about-award-footer about-award-footer-adress text-dark">
                                    <h6 className="mb-2">CONTACT US</h6>
                                    <p>
                                        <i className="fa fa-map-marker" /> 1210/1211/1212 Dalamal Tower, ‘A’
                                        Wing, 12th Floor, Plot No.211, Nariman Point, Mumbai – 400 021,
                                        INDIA
                                    </p>
                                    <p>
                                        <i className="fa fa-phone" aria-hidden="true" /> +91-22-4972 4603 /
                                        2202 0032 / 2285 1579
                                    </p>
                                    <p>
                                        <i className="fa fa-mobile" aria-hidden="true" /> +91-9820 507 570
                                    </p>
                                    <p>
                                        <i className="fa fa-envelope-o" aria-hidden="true" />{" "}
                                        itme@india-itme.com
                                    </p>
                                    <p>
                                        <i className="fa fa-clock-o" aria-hidden="true" /> Monday - Friday |
                                        10:00 am to 06:00 pm, IST (GMT +05:30)
                                    </p>
                                </div>
                                <div className="social-links ">
                                    <ul className="m-0 p-0 mt-3">
                                        <li className="d-inline text-dark">Follow Us:</li>
                                        <li className="d-inline">
                                            <a
                                                target="_blank"
                                                href="https://www.facebook.com/indiaitmesociety"
                                            >
                                                <i className="fa fa-facebook border-social rounded-circle text-center" />
                                            </a>
                                        </li>
                                        <li className="d-inline">
                                            <a target="_blank" href="https://x.com/India_ITME">
                                                <i className="fa fa-twitter border-social rounded-circle text-center" />
                                            </a>
                                        </li>
                                        <li className="d-inline">
                                            <a target="_blank" href="https://www.instagram.com/indiaitme/">
                                                <i className="fa fa-instagram border-social rounded-circle text-center" />
                                            </a>
                                        </li>
                                        <li className="d-inline">
                                            <a
                                                target="_blank"
                                                href="https://www.linkedin.com/company/india-itme?trk=biz-companies-cym"
                                            >
                                                <i className="fa fa-linkedin border-social rounded-circle text-center" />
                                            </a>
                                        </li>
                                        <li className="d-inline">
                                            <a
                                                target="_blank"
                                                href="https://www.youtube.com/c/IndiaITMESociety"
                                            >
                                                <i className="fa fa-youtube-play border-social rounded-circle text-center" />
                                            </a>
                                        </li>
                                        <li className="d-inline">
                                            <a target="_blank" href="skype:indiaitme2012?call">
                                                <i className="fa fa-skype border-social rounded-circle text-center" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="copyright pb-6 pt-1 mt-4 text-dark border-top">
                            <br />
                            <small>Copyright ©2025 ITME. All Rights Reserved.</small>
                        </div>
                    </div>
                </footer>*/}

            </>
        );
    }
}
export default withRouter(
    connect(null, {getCmsContent_action})(StaticFooter)
);
